module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bigDiv"
  }, [_c('div', {
    staticClass: "tipDiv1"
  }, [_c('div', {
    staticClass: "topDiv"
  }, [_c('div', {
    staticClass: "titleDiv"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon009@2x.png")
    }
  }), _vm._v("由专业设计师为您设计")])]), _vm._v(" "), _c('div', {
    staticClass: "titleDiv"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon009@2x.png")
    }
  }), _vm._v("皮质封面，精美大方")])]), _vm._v(" "), _c('div', {
    staticClass: "titleDiv"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon009@2x.png")
    }
  }), _vm._v("高清相片纸、防水防污耐磨")])]), _vm._v(" "), _c('div', {
    staticClass: "titleDiv"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon009@2x.png")
    }
  }), _vm._v("扫描二维码即可播放视频")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tipDiv"
  }, [_c('div', {
    staticClass: "topDiv"
  }, [_c('div', {
    staticClass: "titleDiv"
  }, [_c('span', [_vm._v("1、")]), _c('span', [_vm._v("活动时间：2020年10月1日-2020年10月31日")])]), _vm._v(" "), _c('div', {
    staticClass: "titleDiv"
  }, [_c('span', [_vm._v("2、")]), _c('span', [_vm._v("活动产品：APP中所有相册产品均参与本次活动")])]), _vm._v(" "), _c('div', {
    staticClass: "titleDiv"
  }, [_c('span', [_vm._v("3、")]), _c('span', [_vm._v("参与方式：下载棉花IN,选择您心仪的相册产品即可参与活动")])]), _vm._v(" "), _c('div', {
    staticClass: "titleDiv"
  }, [_c('span', [_vm._v("4、")]), _c('span', [_vm._v("具体活动规则/条件等，以棉花IN最新发布的“优惠规则”、协议及公告为准。如有疑问，可联系客服咨询。客服工作时间：7:00-24:00")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08cb28ee"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operation/exclusiveDest.vue
// module id = 438
// module chunks = 1